<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a><strong><em>In loving memory of my parents, Chris and Dorothy Preus, with thanks for their stories</em></strong><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0cd4f99c